import createRequester from "./countryRequester";

// eslint-disable-next-line import/prefer-default-export
export const save = (element, country) =>
  createRequester(country)
    .then(requester => requester.post("/api/rs-surveys/save", element))
    .then(res => res.data);
